const ENV = window._global.ENV

function appendJS(jsUrl) {
  var script = document.createElement('script')
  script.src = jsUrl
  document.body.appendChild(script)
}

function appendCSS(cssUrl) {
  var link = document.createElement('link')
  link.rel = 'stylesheet'
  link.type = 'text/css'
  link.href = cssUrl
  document.head.appendChild(link)
}

export const addIeeFeedbackScript = (language) => {
  const timestamp = new Date().getTime()
  const feedbackHost = window._global.FEEDBACK_WEB_HOST || 'https://feedback-web.sit.sf-express.com/static/cn'

  if (ENV === 'PRD') {
    appendJS(feedbackHost + '/feedback.umd.js?timestamp=' + timestamp)
  } else {
    appendJS(feedbackHost + '/feedback-sit.umd.js?timestamp=' + timestamp)
  }
  appendCSS(feedbackHost + '/style.css?timestamp=' + timestamp)
}
